import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 44, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function ChapterTag({ number, label }) {
  return (
    <Reveal y={20} className="mb-5 flex items-center gap-3">
      <span className="font-mono text-xs tracking-[0.3em] text-ice uppercase">{number}</span>
      <span className="h-px w-10 bg-ice/50" />
      <span className="font-mono text-xs tracking-[0.3em] text-steel uppercase">{label}</span>
    </Reveal>
  );
}

export function SectionTitle({ children, className = "" }) {
  return (
    <Reveal delay={0.05}>
      <h2 className={`font-display text-4xl sm:text-5xl lg:text-6xl font-bold uppercase leading-[0.95] tracking-tight text-frost ${className}`}>
        {children}
      </h2>
    </Reveal>
  );
}
